import { createSlice } from '@reduxjs/toolkit';

import type { ConversaFeedbackState } from '../types/negociacaoFeedbackTypes';
import { fetchMinhaAvaliacao, registrarAvaliacao, removerAvaliacao } from './actions';

interface NegociacaoFeedbackState {
  byConversa: Record<string, ConversaFeedbackState>;
}

const initialState: NegociacaoFeedbackState = {
  byConversa: {},
};

export const emptyConversaFeedback = (): ConversaFeedbackState => ({
  tipo: null,
  justificativa: null,
  isLoading: false,
  isMutating: false,
  error: null,
});

const ensureEntry = (state: NegociacaoFeedbackState, conversaId: string): ConversaFeedbackState => {
  state.byConversa[conversaId] ??= emptyConversaFeedback();
  return state.byConversa[conversaId];
};

const negociacaoFeedbackSlice = createSlice({
  name: 'negociacaoFeedback',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMinhaAvaliacao.pending, (state, action) => {
        const entry = ensureEntry(state, action.meta.arg);
        entry.isLoading = true;
        entry.error = null;
      })
      .addCase(fetchMinhaAvaliacao.fulfilled, (state, action) => {
        const entry = ensureEntry(state, action.payload.conversaId);
        entry.isLoading = false;
        entry.tipo = action.payload.tipo;
        entry.justificativa = action.payload.justificativa;
      })
      .addCase(fetchMinhaAvaliacao.rejected, (state, action) => {
        const entry = ensureEntry(state, action.meta.arg);
        entry.isLoading = false;
        entry.error = action.payload ?? 'Erro ao carregar avaliação';
      })

      .addCase(registrarAvaliacao.pending, (state, action) => {
        const entry = ensureEntry(state, action.meta.arg.conversaId);
        entry.isMutating = true;
        entry.error = null;
      })
      .addCase(registrarAvaliacao.fulfilled, (state, action) => {
        const entry = ensureEntry(state, action.payload.conversaId);
        entry.isMutating = false;
        entry.tipo = action.payload.tipo;
        entry.justificativa = action.payload.justificativa;
      })
      .addCase(registrarAvaliacao.rejected, (state, action) => {
        const entry = ensureEntry(state, action.meta.arg.conversaId);
        entry.isMutating = false;
        entry.error = action.payload ?? 'Erro ao registrar feedback';
      })

      .addCase(removerAvaliacao.pending, (state, action) => {
        const entry = ensureEntry(state, action.meta.arg);
        entry.isMutating = true;
        entry.error = null;
      })
      .addCase(removerAvaliacao.fulfilled, (state, action) => {
        const entry = ensureEntry(state, action.payload.conversaId);
        entry.isMutating = false;
        entry.tipo = null;
        entry.justificativa = null;
      })
      .addCase(removerAvaliacao.rejected, (state, action) => {
        const entry = ensureEntry(state, action.meta.arg);
        entry.isMutating = false;
        entry.error = action.payload ?? 'Erro ao remover feedback';
      });
  },
});

export default negociacaoFeedbackSlice.reducer;
